// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2vNG1","label":"Category_label__3SRBQ","content":"Category_content__3cblJ","header":"Category_header__sR8Wx","location":"Category_location__37CqU"};